// Entidades de primer nivel (extraídas de sales.js y purchases.js)
// Organizadas por secciones del menú: Contactos, Finanzas, Compras

// Contactos - Clientes
const Clientes = () => import('@/components/ventas/clientes/Clientes.vue');
const HistorialCliente = () => import('@/components/ventas/clientes/Historial-cliente.vue');
const Vendedores = () => import('@/components/ventas/vendedores/Vendedores.vue');
const DetalleVendedor = () => import('@/components/ventas/vendedores/Detalle-vendedor.vue');

// Contactos - Proveedores
const Proveedores = () => import('@/components/compras/proveedores/Proveedores.vue');
const NuevoProveedor = () => import('@/components/compras/proveedores/Nuevo-proveedor.vue');
const Transportes = () => import('@/components/compras/transportes/Transportes.vue');

// Finanzas - Cobranzas
const CCClientes = () => import('@/components/ventas/cc-clientes/CC-clientes.vue');
const DetalleCCCliente = () => import('@/components/ventas/cc-clientes/Detalle-cc-cliente.vue');
const Collections = () => import('@/components/ventas/cobranzas/Collections.vue');
const DetalleRecibo = () => import('@/components/receipt/Receipt-detail.vue');
const DetalleImputacion = () => import('@/components/receipt/Allocation-detail.vue');

// Finanzas - Pagos
const CCProveedores = () => import('@/components/compras/cc-proveedores/CC-proveedores.vue');
const DetalleCCProveedor = () => import('@/components/compras/cc-proveedores/Detalle-cc-proveedor.vue');

const entities = [
  // ======== CONTACTOS - Clientes (menu: clientes) ========
  {
    path: 'clientes',
    name: 'Clientes',
    component: Clientes,
    meta: { title: 'Clientes', menu: 'clientes' },
  },
  {
    path: 'clientes/:clientId/historial',
    name: 'Historial de ventas del cliente',
    component: HistorialCliente,
    props: true,
    meta: { menu: 'clientes' },
  },
  {
    path: 'vendedores',
    name: 'Vendedores',
    component: Vendedores,
    meta: { title: 'Vendedores', menu: 'clientes' },
  },
  {
    path: 'vendedores/:salesClerkId',
    name: 'Detalle de vendedor',
    component: DetalleVendedor,
    props: true,
    meta: { menu: 'clientes' },
  },

  // ======== CONTACTOS - Proveedores (menu: proveedores) ========
  {
    path: 'proveedores',
    name: 'Proveedores',
    component: Proveedores,
    meta: { title: 'Proveedores', menu: 'proveedores' },
  },
  {
    path: 'proveedores/nuevo',
    name: 'Nuevo proveedor',
    component: NuevoProveedor,
    meta: { title: 'Nuevo Proveedor', menu: 'proveedores' },
  },
  {
    path: 'transportes',
    name: 'Transportes',
    component: Transportes,
    meta: { title: 'Transportes', menu: 'proveedores' },
  },

  // ======== FINANZAS - Cobranzas (menu: cobranzas) ========
  {
    path: 'cc-clientes',
    name: 'Cuenta corriente de clientes',
    component: CCClientes,
    meta: { title: 'Cuenta Corriente de Clientes', menu: 'cobranzas' },
  },
  {
    path: 'cc-clientes/:clientId',
    name: 'Detalle de cuenta corriente de cliente',
    component: DetalleCCCliente,
    props: true,
    meta: { menu: 'cobranzas' },
  },
  {
    path: 'cobranzas',
    name: 'Cobranzas',
    component: Collections,
    meta: { title: 'Cobranzas', menu: 'cobranzas' },
  },
  {
    path: 'cobranzas/recibos/:receiptId',
    name: 'DetalleRecibo',
    component: DetalleRecibo,
    props: true,
    meta: { menu: 'cobranzas' },
  },
  {
    path: 'cobranzas/imputaciones/:allocationId',
    name: 'DetalleImputacion',
    component: DetalleImputacion,
    props: true,
    meta: { menu: 'cobranzas' },
  },

  // ======== FINANZAS - Pagos (menu: pagos) ========
  {
    path: 'cc-proveedores',
    name: 'Cuenta corriente de proveedores',
    component: CCProveedores,
    meta: { title: 'Cuenta Corriente de Proveedores', menu: 'pagos' },
  },
  {
    path: 'cc-proveedores/:providerId',
    name: 'Detalle de cuenta corriente de proveedor',
    component: DetalleCCProveedor,
    props: true,
    meta: { title: 'Detalle CC Proveedor', menu: 'pagos' },
  },
];

export default entities;
